export const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 700 ? 700 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'auto',
    overflow: 'auto',
    maxHeight: '90vh',
};

const greenPrimary = '#7ebc0a';
const lightGreen = 'hsla(86, 86.40%, 68.20%, 0.50)';
export const customStyles = {
    menu: (provided) => ({
        ...provided,
        position: 'absolute',
        zIndex: 9999,
        maxHeight: 300,
    }),
    menuPortal: (base) => ({...base, zIndex: 9999}),
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused ? greenPrimary : base.borderColor,
        boxShadow: state.isFocused ? `0 0 0 1px ${greenPrimary}` : base.boxShadow,
        '&:hover': {
            borderColor: greenPrimary,
        },
    }),
    singleValue: (base) => ({
        ...base,
        color: '#000',
    }),
    placeholder: (base) => ({
        ...base,
        color: '#000',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: (state.isSelected || state.isFocused) ? lightGreen : base.backgroundColor,
        color: '#000',
        border: 'none',
        borderTop: 'none',
        borderBottom: 'none',
        outline: 'none',
        WebkitTapHighlightColor: 'transparent',
    }),
};

export const greenTheme = {
  primary: '#7ebc0a',
  hover: '#6aa309',
  disabled: '#a0c97a',
}

const telegramBlue = '#0088cc'

export const sipClientStyles = {
  audioHidden: {
    position: 'fixed',
    left: -9999,
    top: -9999,
    width: 1,
    height: 1,
    opacity: 0,
  },
  toggleButton: (statusColor) => ({
    position: 'fixed',
    right: 94,
    bottom: 26,
    zIndex: 1000,
    width: 52,
    height: 52,
    borderRadius: '50%',
    border: 'none',
    background: statusColor,
    color: 'white',
    boxShadow: '0 4px 14px rgba(0,0,0,0.18)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  panel: {
    position: 'fixed',
    right: 94,
    bottom: 26,
    zIndex: 1000,
    width: 300,
    padding: 16,
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 10px 40px rgba(0,0,0,0.12), 0 0 1px rgba(0,0,0,0.08)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
    paddingBottom: 10,
    borderBottom: '1px solid #e2e8f0',
  },
  headerTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  headerTitle: {
    fontWeight: 900,
    fontSize: 17,
    color: '#1e293b',
  },
  headerRegDot: (registered) => ({
    width: 10,
    height: 10,
    borderRadius: '50%',
    background: registered ? '#22c55e' : '#ef4444',
    display: 'inline-block',
  }),
  closeBtn: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    lineHeight: 1,
    color: '#64748b',
    fontSize: 18,
  },
  errorBox: {
    marginBottom: 12,
    padding: 12,
    background: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: 12,
    color: '#b91c1c',
    fontSize: 12,
  },
  numberInput: {
    width: '100%',
    height: 44,
    padding: '0 14px',
    borderRadius: 12,
    border: `2px solid #e2e8f0`,
    boxSizing: 'border-box',
    fontSize: 15,
    outline: 'none',
  },
  dialPadGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 8,
    marginTop: 12,
  },
  padBtn: {
    width: '100%',
    height: 48,
    borderRadius: 14,
    border: '1px solid #e2e8f0',
    background: '#fff',
    color: '#0f172a',
    fontSize: 17,
    fontWeight: 900,
    cursor: 'pointer',
    userSelect: 'none',
  },
  padZeroPlus: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
  },
  padZeroPlusLabel: {
    fontSize: 12,
    color: '#94a3b8',
  },
  actionRow: {
    display: 'flex',
    gap: 8,
    marginTop: 10,
  },
  backspaceBtn: {
    flex: 1,
    height: 42,
    borderRadius: 12,
    border: '1px solid #e2e8f0',
    background: '#fff',
    fontWeight: 900,
    color: '#64748b',
    cursor: 'pointer',
  },
  clearBtn: {
    flex: 1,
    height: 42,
    borderRadius: 12,
    border: '1px solid #fecaca',
    background: '#fff',
    fontWeight: 900,
    color: '#ef4444',
    cursor: 'pointer',
  },
  callBtnWrap: {
    marginTop: 12,
    display: 'flex',
    justifyContent: 'center',
  },
  callBtn: (canCall) => ({
    width: 52,
    height: 52,
    border: 'none',
    cursor: canCall ? 'pointer' : 'not-allowed',
    borderRadius: '50%',
    background: canCall ? greenTheme.primary : '#cbd5e1',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
}

export const inputStyles = {
  '& .MuiOutlinedInput-root': {
    minHeight: '41px',
    '& fieldset': { borderColor: greenTheme.primary },
    '&:hover fieldset': { borderColor: greenTheme.hover },
    '&.Mui-focused fieldset': { borderColor: greenTheme.primary },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: greenTheme.primary,
  },
}

export const selectStyles = {
  '& .MuiOutlinedInput-root': {
    minHeight: '41px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: greenTheme.primary,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: greenTheme.hover,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: greenTheme.primary,
  },
}

export const inputLabelStyles = {
  '&.Mui-focused': {
    color: greenTheme.primary,
  },
}

export const sectionTitleStyles = {
  mb: 2,
  fontWeight: 600,
  marginTop:5,
  color: '#334155',
}

export const buttonStyles = {
  backgroundColor: greenTheme.primary,
  color: '#fff',
  px: 3,
  py: 0.75,
  fontSize: '0.875rem',
  fontWeight: 600,
  textTransform: 'none',
  minHeight: '41px',
  '&:hover': {
    backgroundColor: greenTheme.hover,
  },
  '&:disabled': {
    backgroundColor: greenTheme.disabled,
  },
}

export const mainPaperStyles = {
  p: 4,
  borderRadius: 3,
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
}

export const headerBoxStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  mb: 4,
  pb: 2,
  borderBottom: '2px solid rgba(0,0,0,0.1)'
}

export const backButtonStyles = {
  color: greenTheme.primary,
  // backgroundColor: 'rgba(126, 188, 10, 0.1)',
  '&:hover': {
    backgroundColor: 'rgba(126, 188, 10, 0.2)',
  },
  transition: 'all 0.3s ease'
}

export const titleTypographyStyles = {
  fontWeight: 700,
  m: 0,
  color: 'text.primary',
  fontSize: '1.75rem'
}

export const alertStyles = {
  mb: 3,
  borderRadius: 2,
  backgroundColor: 'rgba(126, 188, 10, 0.1)',
  border: `1px solid ${greenTheme.primary}`,
  '& .MuiAlert-icon': {
    color: greenTheme.primary
  }
}

export const alertTypographyStyles = {
  color: 'text.primary',
  fontWeight: 500
}

export const innerPaperStyles = {
  p: 4,
  border: `1px solid ${greenTheme.primary}`,
  borderRadius: 3,
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
}

export const sectionTitleWithBorderStyles = {
  ...sectionTitleStyles,
  mb: 3,
  pb: 2,
  borderBottom: `2px solid ${greenTheme.primary}`,
  fontWeight: 600
}

export const checkboxStyles = {
  color: greenTheme.primary,
  '&.Mui-checked': {
    color: greenTheme.primary,
  },
}

export const captionTypographyStyles = {
  mb: 1,
  display: 'block',
  fontWeight: 500,
  color: 'text.secondary'
}

export const profileDividerBoxStyles = {
  mt: 2,
  pt: 3,
  borderTop: '1px solid rgba(0,0,0,0.1)'
}

export const profileSectionTitleStyles = {
  ...sectionTitleStyles,
  mb: 3,
  fontSize: '1.1rem',
  fontWeight: 600
}

export const buttonContainerBoxStyles = {
  display: 'flex',
  justifyContent: 'center',
  mt: 4,
  pt: 3,
  borderTop: `1px solid ${greenTheme.primary}`
}

export const saveButtonStyles = {
  ...buttonStyles,
  minWidth: 220,
  py: 1.75,
  px: 4,
  fontSize: '1.05rem',
  fontWeight: 600,
  background: `linear-gradient(135deg, ${greenTheme.primary} 0%, #6ba809 100%)`,
  boxShadow: '0 4px 12px rgba(126, 188, 10, 0.3)',
  borderRadius: 2,
  textTransform: 'none',
  letterSpacing: '0.5px',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
    transition: 'left 0.5s ease',
  },
  '&:hover::before': {
    left: '100%',
  },
  '&:hover': {
    background: `linear-gradient(135deg, #6ba809 0%, ${greenTheme.primary} 100%)`,
    boxShadow: '0 6px 16px rgba(126, 188, 10, 0.4)',
    transform: 'translateY(-2px) scale(1.02)',
  },
  '&:active': {
    transform: 'translateY(0) scale(0.98)',
    boxShadow: '0 2px 8px rgba(126, 188, 10, 0.3)',
  },
  '&:disabled': {
    background: 'rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.26)',
    boxShadow: 'none',
  },
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
}

export const colors = {
  primary: '#4caf50',
  primaryDark: '#388e3c',
  primaryLight: '#81c784',
  background: '#e8f5e9',
  backgroundLight: '#f1f8e9',
  text: '#212121',
  textSecondary: '#757575',
  border: '#c8e6c9',
}

export const chatStyles = {
    container: {
      height: 'calc(100vh - 200px)',
      display: 'flex',
      gap: 0,
      overflow: 'hidden',
      borderRadius: 2,
      boxShadow: 3,
      position: 'relative',
    },
  searchBar: {
    p: 2.5,
    borderBottom: '1px solid #e8eaf6',
    backgroundColor: '#fafafa',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  searchInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 3,
      backgroundColor: '#ffffff',
      '& fieldset': {
        borderColor: '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: '#bdbdbd',
      },
      '&.Mui-focused fieldset': {
        borderColor: telegramBlue,
      },
    },
  },
  chatList: {
    flex: 1,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a8a8a8',
    },
  },
  chatItem: {
    py: 1.5,
    px: 2,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '&.Mui-selected': {
      backgroundColor: colors.background,
      borderLeft: `3px solid ${telegramBlue}`,
      '&:hover': {
        backgroundColor: colors.background,
      },
    },
  },
    avatar: (isSelected) => ({
      bgcolor: isSelected ? telegramBlue : '#9e9e9e',
      width: 48,
      height: 48,
      fontSize: '1.1rem',
      fontWeight: 600,
    }),
    chatName: (isSelected) => ({
      fontWeight: isSelected ? 600 : 500,
      fontSize: '0.95rem',
      color: isSelected ? telegramBlue : colors.text,
    }),
    conversation: {
      flex: 1,
      flexDirection: 'column',
      borderRadius: { xs: 0, md: '0 8px 8px 0' },
      height: '100%',
      overflow: 'hidden',
      backgroundColor: '#ffffff',
      boxShadow: 'none',
    },
  chatHeader: {
    p: 2.5,
    borderBottom: '1px solid #e8eaf6',
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  menuButton: {
    mr: 1,
    color: '#757575',
    '&:hover': {
      backgroundColor: colors.background,
    },
  },
  closeButton: {
    mr: 1,
    color: colors.textSecondary,
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  messagesThread: {
    flex: 1,
    overflowY: 'auto',
    p: 3,
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a8a8a8',
    },
  },
  messageBubble: (isUser, isSystem) => ({
    maxWidth: '75%',
    p: 1.75,
    borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
    backgroundColor: isUser
      ? '#0088cc14'
      : isSystem
        ? '#ffffff'
        : '#ffffff',
    color: isUser ? '#000000' : colors.text,
    boxShadow: '0px 0px 4px 4px rgba(0, 0, 0, 0.1)',
    border: isUser ? '1px solid #ccc' : isSystem ? '1px solid #e0e0e0' : '1px solid #e0e0e0',
    transition: 'transform 0.1s ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0px 0px 4px 4px rgba(0, 0, 0, 0.1)',
    },
  }),
  messageLabel: (isSystem) => ({
    display: 'block',
    mb: 0.75,
    fontWeight: 600,
    fontSize: '0.75rem',
    color: isSystem ? '#9e9e9e' : greenTheme.primary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  }),
  inputArea: {
    p: 2.5,
    borderTop: '1px solid #e8eaf6',
    backgroundColor: '#ffffff',
    display: 'flex',
    gap: 1.5,
    alignItems: 'flex-end',
    boxShadow: '0 -2px 8px rgba(0,0,0,0.05)',
  },
  messageInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      backgroundColor: '#ffffff',
      '& fieldset': {
        borderColor: '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(0, 136, 204, 0.5)',
      },
      '&.Mui-focused fieldset': {
        borderColor: telegramBlue,
        borderWidth: '2px',
      },
    },
  },
    sendButton: (hasMessage) => ({
      backgroundColor: hasMessage ? 'transparent' : '#e0e0e0',
      color: hasMessage ? telegramBlue : '#9e9e9e',
      '&:hover': {
        backgroundColor: hasMessage ? 'rgba(0, 136, 204, 0.08)' : '#d5d5d5',
      },
      width: 44,
      height: 44,
      transition: 'all 0.2s ease',
      boxShadow: 'none',
    }),
    emptyState: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      backgroundImage: `radial-gradient(circle at 20% 50%, rgba(126, 188, 10, 0.03) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(126, 188, 10, 0.03) 0%, transparent 50%)`,
      position: 'relative',
    },
    emptyStateButton: {
      position: 'absolute',
      top: 20,
      left: 20,
      color: greenTheme.primary,
      backgroundColor: colors.background,
      '&:hover': {
        backgroundColor: colors.backgroundLight,
      },
      boxShadow: `0 2px 8px rgba(126, 188, 10, 0.2)`,
    },
    sidebar: {
      width: { xs: '100%', md: 380 },
      flexDirection: 'column',
      borderRadius: { xs: 0, md: '8px 0 0 8px' },
      borderRight: '1px solid #e0e0e0',
      height: '100%',
      overflow: 'hidden',
      backgroundColor: '#ffffff',
      boxShadow: 'none',
      transition: 'transform 0.3s ease',
      position: { xs: 'relative', md: 'relative' },
    },
    loadingBox: {
      p: 4,
      textAlign: 'center',
    },
    secondaryText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
      color: '#757575',
      fontSize: '0.8rem',
      mt: 0.5,
    },
    timestamp: {
      ml: 1,
      color: '#9e9e9e',
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
    },
    conversationPaper: {
      flex: 1,
      flexDirection: 'column',
      borderRadius: { xs: 0, md: '0 8px 8px 0' },
      height: '100%',
      overflow: 'hidden',
      backgroundColor: '#ffffff',
      boxShadow: 'none',
    },
    headerAvatar: {
      bgcolor: telegramBlue,
      width: 48,
      height: 48,
      fontSize: '1.1rem',
      fontWeight: 600,
    },
    headerInfoBox: {
      flex: 1,
    },
    headerName: {
      fontWeight: 600,
      fontSize: '1.1rem',
      color: colors.text,
    },
    headerPhone: {
      color: colors.textSecondary,
      fontSize: '0.85rem',
    },
    daySeparatorBox: {
      display: 'flex',
      justifyContent: 'center',
      my: 3,
    },
    dayLabel: {
      px: 2.5,
      py: 0.75,
      borderRadius: 3,
      backgroundColor: '#ffffff',
      color: '#757575',
      fontSize: '0.75rem',
      fontWeight: 500,
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    messageContainer: {
      display: 'flex',
      mb: 1.5,
      px: 1,
    },
    messageText: {
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      lineHeight: 1.5,
      fontSize: '0.95rem',
    },
    answererLabel: (isUser) => ({
      display: 'block',
      mb: 0.75,
      pb: 0.5,
      borderBottom: isUser ? '1px solid rgba(0,0,0,0.1)' : '1px solid rgba(126, 188, 10, 0.25)',
      fontSize: '0.7rem',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      color: isUser ? 'rgba(0,0,0,0.55)' : greenTheme.primary,
    }),
    messageTimestamp: {
      display: 'block',
      mt: 0.75,
      opacity: 0.6,
      fontSize: '0.7rem',
      textAlign: 'right',
    },
    emptyStateText: {
      textAlign: 'center',
      p: 4,
    },
    loadingMessagesBox: {
      textAlign: 'center',
      py: 6,
    },
    emptyMessagesBox: {
      textAlign: 'center',
      py: 6,
    },
    emptyStateTitle: {
      mb: 1,
      fontWeight: 500,
    },
    emptyStateSubtitle: {
      opacity: 0.7,
    },
    chatListContainer: {
      p: 0,
    },
    listItemAvatar: {
      minWidth: 50,
      marginRight: 2,
    },
    divider: {
      mx: 2,
    },
    searchIcon: {
      color: '#9e9e9e',
    },
}

export const cardStyles = {
  card: {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    borderRadius: 3,
    overflow: 'hidden',
    background: 'linear-gradient(to right, #ffffff 0%, #fafafa 100%)',
    width: '100%',
    minHeight: 220,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '&:hover': {
      boxShadow: '0 8px 24px rgba(126, 188, 10, 0.15)',
      transform: 'translateY(-4px)',
      borderColor: greenTheme.primary,
    },
  },
  cardContent: {
    p: 3,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
}

export const activitiesStyles = {
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 3,
    pb: 2,
    borderBottom: '2px solid rgba(0, 0, 0, 0.08)',
    pb: 2.3,
  },
  headerContentBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
   
  },
  backButton: {
    size: 'small',
    color: greenTheme.primary,
    fontSize: 18,
  },
  backIcon: {
    fontSize: 20,
    fontWeight: 700,
  },
  accentBar: {
    width: 4,
    height: 40,
    backgroundColor: greenTheme.primary,
    borderRadius: 2,
  },
  titleTypography: {
    variant: 'h5',
    fontWeight: 700,
    m: 0,
  },
  searchButton: {
    backgroundColor: greenTheme.primary,
    '&:hover': {
      backgroundColor: greenTheme.hover,
    },
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    py: 8,
  },
  loadingSpinner: {
    color: greenTheme.primary,
  },
  activitiesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2.5,
  },
  activityCard: {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    borderRadius: 3,
    overflow: 'hidden',
    background: 'linear-gradient(to right, #ffffff 0%, #fafafa 100%)',
    minHeight: 180,
    '&:hover': {
      boxShadow: '0 8px 24px rgba(126, 188, 10, 0.15)',
      transform: 'translateY(-4px)',
      borderColor: greenTheme.primary,
    },
  },
  cardContent: {
    p: 3,
  },
  cardContentBox: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 3,
  },
  getActivityAvatar: (isAdmin) => ({
    bgcolor: isAdmin ? greenTheme.primary : '#9e9e9e',
    width: 56,
    height: 56,
    fontSize: '1.25rem',
    fontWeight: 700,
    boxShadow: '0 4px 12px rgba(126, 188, 10, 0.3)',
  }),
  activityContentBox: {
    flex: 1,
    minWidth: 0,
  },
  chipsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    mb: 1.5,
    flexWrap: 'wrap',
  },
  methodChip: {
    fontWeight: 600,
    fontSize: '0.75rem',
    height: 24,
    lineHeight:'normal',
  },
  adminChip: {
    borderColor: greenTheme.primary,
    color: greenTheme.primary,
    fontWeight: 500,
  },
  chipActive: {
    backgroundColor: greenTheme.primary,
    color: '#fff',
    borderColor: greenTheme.primary,
  },
  chipInactive: {
    backgroundColor: 'grey.200',
    color: 'grey.600',
    borderColor: 'grey.300',
  },
  activityTitle: {
    fontWeight: 600,
    fontSize: '1rem',
    mb: 1,
    color: '#212121',
    wordBreak: 'break-word',
  },
  metadataBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    flexWrap: 'wrap',
    mt: 2,
    pt: 2,
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  },
  metadataItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    color: 'text.secondary',
  },
  metadataIcon: {
    color: greenTheme.primary,
    fontSize: '18px',
  },
  iconSquareBox: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '2px',
    border: '1px solid',
    borderColor: 'divider',
    mr: 0.5,
  },
  iconSlashOverlay: {
    position: 'relative',
    display: 'inline-flex',
    mr: 0.5,
    '&::after': {
      content: '""',
      position: 'absolute',
      left: -3,
      top: '37%',
      width: '128%',
      height: 2,
      backgroundColor: 'red',
      transform: 'rotate(46deg)',
      transformOrigin: 'center center',
    },
  },
  metadataText: {
    fontSize: '0.8rem',
    fontWeight: 500,
  },
  ipText: {
    fontSize: '0.8rem',
    fontWeight: 500,
    fontFamily: 'monospace',
  },
  loginBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 100,
    p: 2,
    borderRadius: 2,
    backgroundColor: 'rgba(126, 188, 10, 0.08)',
    border: '1px solid rgba(126, 188, 10, 0.2)',
  },
  loginIcon: {
    color: greenTheme.primary,
    fontSize: 28,
    mb: 0.5,
  },
  loginText: {
    fontWeight: 600,
    color: greenTheme.primary,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  detailsBox: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 70,
    p: 1.5,
    borderRadius: 2,
    backgroundColor: greenTheme.primary,
    color: '#fff',
    transition: 'all 0.2s ease',
    height: 40,
    '&:hover': {
      backgroundColor: greenTheme.hover,
      transform: 'scale(1.05)',
      boxShadow: '0 4px 12px rgba(126, 188, 10, 0.4)',
    },
  },
  detailsIcon: {
    fontSize: 20,
    mb: 0.25,
  },
  detailsText: {
    fontWeight: 600,
    fontSize: '0.65rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  detailsArrow: {
    fontSize: 14,
    mt: 0.25,
    transition: 'transform 0.2s ease',
  },
  confirmedBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 100,
    p: 2,
    borderRadius: 2,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  confirmedIcon: {
    color: 'text.secondary',
    fontSize: 28,
    mb: 0.5,
  },
  confirmedText: {
    fontWeight: 500,
    color: 'text.secondary',
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  emptyStateBox: {
    textAlign: 'center',
    py: 8,
  },
  paginationBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 3,
  },
}

export const employeeTableStyles = {
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2,
  },
  headerTitleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width: '100%',
    flexWrap: 'wrap',
    borderBottom: '2px solid rgba(0, 0, 0, 0.08)',
    pb: 2.5,
    mb: 1,
  },
  title: {
    fontWeight: 700,
    m: 0,
  },
  searchSortContainer: {
    mb: 3,
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  searchBox: {
    flex: 1,
    minWidth: 250,
    maxWidth: 900,
  },
  sortContainer: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
    minWidth: 169,
  },
  sortFormControl: {
    minWidth: 169,
    '& .MuiInputLabel-root.Mui-focused': {
      color: greenTheme.primary,
    },
  },
  sortSelect: {
    '& .MuiSelect-select': {
      py: 1,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: greenTheme.primary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: greenTheme.hover,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: greenTheme.primary,
    },
  },
  getSortIconButton: (color) => ({
    color: color,
    border: `1px solid ${color}`,
    '&:hover': {
      backgroundColor: `${color}15`,
    },
  }),
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    py: 8,
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: 80,
  },
  activeIcon: (color) => ({
    color: color,
    fontSize: 24,
    mb: 0.75,
    filter: 'drop-shadow(0 2px 4px rgba(126, 188, 10, 0.3))',
  }),
  getIpAddressText: (color, isClickable) => ({
    cursor: isClickable ? 'pointer' : 'default',
    fontSize: '0.7rem',
    fontFamily: 'monospace',
    textAlign: 'center',
    wordBreak: 'break-word',
    maxWidth: '80px',
    '&:hover': isClickable
      ? {
          textDecoration: 'underline',
          color: color,
        }
      : {},
  }),
  actionButtonsBox: {
    display: 'flex',
    gap: 1,
    mt: 0.5,
  },
  editIconButton: {
    color: '#7ebc0a',
    '&:hover': {
      backgroundColor: 'rgba(126, 188, 10, 0.1)',
      transform: 'scale(1.1)',
    },
    transition: 'all 0.2s ease',
    padding: '6px',
  },
  deleteIconButton: {
    color: '#ce405f',
    '&:hover': {
      backgroundColor: 'rgba(206, 64, 95, 0.1)',
      transform: 'scale(1.1)',
    },
    transition: 'all 0.2s ease',
    padding: '6px',
  },
  footerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 3,
    flexWrap: 'wrap',
    gap: 2,
  },
  footerLinksBox: {
    display: 'flex',
    gap: 1,
    flexWrap: 'wrap',
    '& .MuiChip-root': {
      borderRadius: '7px',
      cursor: 'pointer',
    },
    '& .MuiChip-root:hover': {
      backgroundColor: '#7ebc0a !important',
      color: '#fff !important',
      borderColor: '#7ebc0a !important',
    },
    '& .MuiChip-root:hover .MuiChip-label': {
      color: '#fff !important',
    },
  },
  footerLink: {
    margin: '0 10px',
    cursor: 'pointer',
  },
  emptyStateBox: {
    textAlign: 'center',
    py: 8,
  },
}

export const fileStyles = {
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 3,
    borderBottom: '2px solid rgba(0, 0, 0, 0.08)',
    pb: 2.5,
  },
  title: { fontWeight: 700, m: 0 },
  formPaper: (color) => ({
    p: 3,
    border: `1px solid ${color}`,
  }),
  formTitle: { mb: 2, fontWeight: 600, color: '#334155' },
  inputField: (color) => ({
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: color },
      '&:hover fieldset': { borderColor: color },
      '&.Mui-focused fieldset': { borderColor: color },
    },
    '& .MuiInputLabel-root.Mui-focused': { color },
  }),
  fileButton: (color) => ({
    minHeight: 41,
    borderColor: color,
    color: color,
    textTransform: 'none',
    justifyContent: 'flex-start',
    '&:hover': {
      borderColor: color,
      backgroundColor: color === '#0973b9' ? 'rgba(9, 115, 185, 0.08)' : 'rgba(126, 188, 10, 0.08)',
    },
  }),
  addButton: (color) => ({
    backgroundColor: color,
    color: '#fff',
    px: 3,
    py: 0.75,
    minHeight: 41,
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': { backgroundColor: color === '#0973b9' ? '#075a94' : '#6aa507' },
  }),
  addFewButton: (color) => ({
    borderColor: color,
    color,
    minHeight: 41,
    textTransform: 'none',
    '&:hover': {
      borderColor: color,
      backgroundColor: color === '#0973b9' ? 'rgba(9, 115, 185, 0.08)' : 'rgba(126, 188, 10, 0.08)',
    },
  }),
  stickyPlayer: (sticky) => ({
    position: sticky ? 'sticky' : 'static',
    top: 0,
    zIndex: 3,
    background: 'white',
    margin: '16px 0',
  }),
  tableParent: { background: 'white', minWidth: 720, padding: 35 },
  playerPaper: {
    position: 'sticky',
    top: 0,
    zIndex: 1100,
    mt: 2,
    p: 1.5,
    borderRadius: 2,
    border: '1px solid #e5e8ed',
    bgcolor: '#fff',
    alignSelf: 'flex-start',
  },
  playerIconButton: {
    color: '#7ebc0a',
    '&:hover': { backgroundColor: 'rgba(126, 188, 10, 0.08)' },
    '&.Mui-disabled': { color: '#ccc' },
  },
  playerLabel: { minWidth: 120, maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: 'text.secondary' },
  seekSlider: {
    color: '#7ebc0a',
    '& .MuiSlider-thumb': { width: 14, height: 14 },
    '& .MuiSlider-rail': { opacity: 0.5 },
  },
  volumeSlider: {
    color: '#7ebc0a',
    '& .MuiSlider-thumb': { width: 12, height: 12 },
    '& .MuiSlider-rail': { opacity: 0.5 },
  },
  searchField: {
    mb: 2,
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: '#7ebc0a' },
      '&:hover fieldset': { borderColor: '#6aa507' },
      '&.Mui-focused fieldset': { borderColor: '#7ebc0a' },
    },
  },
  searchIcon: { color: '#7ebc0a', fontSize: 22 },
  fileListTitle: { fontWeight: 700, mb: 2, pb: 1.5, borderBottom: '1px solid #e5e8ed' },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: 1.5,
    mt: 1,
  },
  fileCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    px: 2,
    py: 1.5,
    border: '1px solid #e5e8ed',
    borderRadius: 2,
    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.04)',
    transition: 'box-shadow 0.35s, border-color 0.35s',
    '&:hover': {
      borderColor: '#7ebc0a',
      boxShadow: '0 6px 20px rgba(126, 188, 10, 0.35)',
    },
  },
  editTextField: (color) => ({
    flex: 1,
    minWidth: 0,
    '& .MuiOutlinedInput-root': {
      fontSize: '0.875rem',
      '& fieldset': { borderColor: color },
      '&.Mui-focused fieldset': { borderColor: color },
    },
  }),
  saveButton: (color) => ({ color, minWidth: 32, p: 0.5, textTransform: 'none' }),
  cancelButton: { color: 'text.secondary', minWidth: 32, p: 0.5, textTransform: 'none' },
  labelText: { flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  playButton: (color) => ({
    minWidth: 36,
    color,
    p: 0.5,
    '&:hover': { backgroundColor: color === '#0973b9' ? 'rgba(9, 115, 185, 0.08)' : 'rgba(126, 188, 10, 0.08)' },
  }),
  deleteIconButton: {
    color: '#d32f2f',
    p: 0.5,
    '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.08)' },
  },
  editIconButton: {
    color: '#1976d2',
    p: 0.5,
    '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' },
  },
}

export const telegramConnectStyles = {
  formTextField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: greenTheme.primary },
      '&:hover fieldset': { borderColor: greenTheme.hover },
      '&.Mui-focused fieldset': { borderColor: greenTheme.primary },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: greenTheme.primary,
    },
  },
  formSelect: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: greenTheme.primary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: greenTheme.hover,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: greenTheme.primary,
    },
  },
  formInputLabel: {
    '&.Mui-focused': {
      color: greenTheme.primary,
    },
  },
  primaryButton: {
    backgroundColor: greenTheme.primary,
    '&:hover': { backgroundColor: greenTheme.hover },
    flex: 1,
  },
  outlinedButton: {
    borderColor: '#d1d5db',
    color: '#374151',
    '&:hover': { borderColor: '#9ca3af' },
  },
  statusBadge: (status) => ({
    fontSize: 13,
    backgroundColor:
      status === 'ready' ? greenTheme.primary : status === 'error' ? '#ef4444' : '#6b7280',
    color: '#fff',
    fontWeight: 500,
    padding: '4px 12px',
    borderRadius: '12px',
    display: 'inline-block',
  }),
  emptyStateBox: {
    width: '100%',
    gridColumn: '1 / -1',
    p: 6,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px',
  },
  emptyStateText: {
    fontSize: { xs: '1rem', md: '1.25rem' },
    fontWeight: 500,
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, 1fr)',
      md: 'repeat(3, 1fr)',
    },
    gap: '12px',
  },
  formPaper: {
    p: 3,
    mb: 3,
    backgroundColor: '#f9fafb',
    border: '1px solid #e5e7eb',
  },
  backButton: {
    color: greenTheme.primary,
    fontSize: 18,
  },
}

export const historyChatsStyles = {
  accordionSummary: {
    padding: '0 30px',
    height: 80,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 20,
    margin: 0,
  },
  telegramIcon: {
    width: 30,
    height: 30,
    filter: `invert(1) brightness(0) saturate(100%) invert(55%) sepia(90%) saturate(1200%) hue-rotate(38deg) brightness(0.95) contrast(1.05)`,
  },
  selectorPaper: {
    p: 2.5,
    pb: '10px',
    mt: 2,
    mb: '10px',
    borderRadius: 2,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  },
  selectorTitle: {
    mb: 1.5,
    fontWeight: 600,
    color: '#334155',
    fontSize: '0.95rem',
  },
  selectorGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, 1fr)',
      md: 'repeat(3, 1fr)',
    },
    gap: 1.5,
  },
  accountCard: (isSelected) => ({
    cursor: 'pointer',
    border: isSelected ? `2px solid ${greenTheme.primary}` : '1px solid #e2e8f0',
    borderRadius: 12,
    backgroundColor: isSelected ? 'rgba(126, 188, 10, 0.08)' : '#f8fafc',
    position: 'relative',
    padding: '14px 16px',
    minHeight: 'auto',
    transition: 'border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      backgroundColor: isSelected ? 'rgba(126, 188, 10, 0.12)' : '#f1f5f9',
      borderColor: isSelected ? greenTheme.primary : '#cbd5e1',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    },
  }),
  selectedIndicator: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: 18,
    height: 18,
    borderRadius: '50%',
    backgroundColor: greenTheme.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&::after': {
      content: '"✓"',
      color: '#fff',
      fontSize: '0.7rem',
      fontWeight: 700,
    },
  },
  accountIconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 8,
  },
  accountIcon: {
    width: 28,
    height: 28,
    flexShrink: 0,
    filter: `invert(1) brightness(0) saturate(100%) invert(55%) sepia(90%) saturate(1200%) hue-rotate(38deg) brightness(0.95) contrast(1.05)`,
  },
  accountTitle: (isSelected) => ({
    fontWeight: isSelected ? 600 : 500,
    color: isSelected ? greenTheme.primary : '#334155',
    fontSize: '0.9rem',
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  accountStatusBadge: (status) => ({
    fontSize: 11,
    backgroundColor:
      status === 'ready' ? greenTheme.primary :
      status === 'error' ? '#ef4444' : '#64748b',
    color: '#fff',
    fontWeight: 500,
    padding: '4px 8px',
    borderRadius: 8,
    display: 'inline-block',
  }),
}

const { REACT_APP_SERVER } = process.env
export const reportPrimary = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : greenTheme.primary
export const reportHover = REACT_APP_SERVER === 'ATS' ? '#095a8f' : greenTheme.hover

export const operatorReportStyles = {
  paper: {
    p: 3,
  },
  headerTitle: {
    fontWeight: 700,
    m: 0,
  },
  backIconButton: {
    color: reportPrimary,
    p: 0.5,
  },
  tabs: {
    mt: 3,
    minHeight: 48,
    mb: 2,
    borderBottom: 1,
    borderColor: 'divider',
    '& .MuiTab-root': { minHeight: 48, textTransform: 'none', fontWeight: 600, fontSize: '0.875rem' },
    '& .Mui-selected': { color: `${reportPrimary} !important` },
    '& .Mui-selected .MuiSvgIcon-root': { color: `${reportPrimary} !important` },
    '& .MuiTabs-indicator': { backgroundColor: reportPrimary, height: 3 },
  },
  tabIcon: {
    fontSize: 20,
  },
  operatorSubtext: {
    mb: 2,
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 2,
    mb: 2,
  },
  filterField: {
    minWidth: 160,
    '& .MuiTextField-root': { minWidth: 200 },
    '& .MuiInputBase-root': { borderRadius: 1 },
  },
  filterDateInput: {
    padding: '0 14px',
    height: 40,
    width: '100%',
    minWidth: 140,
    boxSizing: 'border-box',
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    fontSize: 14,
    outline: 'none',
    backgroundColor: '#fff',
    fontFamily: 'inherit',
  },
  filterDateInputWrapper: {
    height: 40,
    minWidth: 140,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    overflow: 'hidden',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    '&:focus-within': {
      borderColor: reportPrimary,
      outline: 'none',
      boxShadow: `0 0 0 1px ${reportPrimary}`,
    },
    '& input': {
      padding: '0 14px',
      height: 38,
      width: '100%',
      minWidth: 120,
      boxSizing: 'border-box',
      border: 'none',
      fontSize: 14,
      outline: 'none',
      backgroundColor: 'transparent',
      fontFamily: 'inherit',
    },
  },
  periodRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 2,
    margin:"27px 0",
    rowGap: 2,
  },
  periodRowGroup: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 2,
  },
  toggleButtonGroup: {
    '& .MuiToggleButton-root': {
      borderColor: reportPrimary,
      color: reportPrimary,
      height: 40,
      fontSize: 13,
      textTransform: 'none',
      '&.Mui-selected': {
        backgroundColor: reportPrimary,
        color: '#fff',
        '&:hover': { backgroundColor: reportHover },
      },
    },
  },
  refreshButton: {
    color: reportPrimary,
    marginLeft: 1,
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    py: 6,
  },
  loadingSpinner: {
    color: reportPrimary,
  },
  sectionBox: {
    scrollMarginTop: 24,
    marginBottom: '27px',
  },
  gridMb: {
    mb: 4,
  },
  cardIconBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    mb: 1,
  },
  cardValueTypography: {
    fontWeight: 700,
  },
  smallCardContent: {
    py: 1.5,
  },
  smallCardInnerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  smallCardLeftBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  performancePaper: (received, answered) => ({
    p: 2.5,
    mb: 4,
    borderRadius: 3,
    boxShadow: 2,
    borderLeft: `4px solid ${received ? (answered / received >= 0.7 ? '#22c55e' : answered / received >= 0.4 ? '#f59e0b' : '#ef4444') : greenTheme.primary}`,
  }),
  performanceTitleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 2,
  },
  performanceIcon: {
    color: greenTheme.primary,
    fontSize: 28,
  },
  performanceSubtitle: {
    fontWeight: 700,
    color: 'text.primary',
  },
  performanceBody: {
    mb: 1,
  },
  performanceBodySecondary: {
    mb: 1.5,
  },
  performanceRatingSpan: {
    fontWeight: 700,
    color: greenTheme.primary,
  },
  performanceLinearProgress: (received, answered) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: 'rgba(239, 68, 68, 0.2)',
    '& .MuiLinearProgress-bar': {
      backgroundColor:
        received && answered / received >= 0.7
          ? '#22c55e'
          : received && answered / received >= 0.4
            ? '#f59e0b'
            : '#ef4444',
    },
  }),
  chipsBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'flex-start', md: 'flex-end' },
    gap: 1.5,
    flexWrap: 'wrap',
  },
  chipAnswered: {
    fontWeight: 600,
    backgroundColor: 'rgba(34, 197, 94, 0.15)',
    color: '#16a34a',
    border: '1px solid #22c55e',
  },
  chipNotAnswered: {
    fontWeight: 600,
    backgroundColor: 'rgba(239, 68, 68, 0.15)',
    color: '#dc2626',
    border: '1px solid #ef4444',
  },
  chipBusy: {
    fontWeight: 600,
    backgroundColor: 'rgba(245, 158, 11, 0.15)',
    color: '#d97706',
    border: '1px solid #f59e0b',
  },
  chipFailed: {
    fontWeight: 600,
    backgroundColor: 'rgba(220, 38, 38, 0.15)',
    color: '#dc2626',
    border: '1px solid #dc2626',
  },
  chipCanceled: {
    fontWeight: 600,
    backgroundColor: 'rgba(107, 114, 128, 0.15)',
    color: '#6b7280',
    border: '1px solid #6b7280',
  },
  chipIcon: {
    fontSize: 18,
  },
  chartPaper: {
    p: 2,
    borderRadius: 3,
    boxShadow: 2,
    height: '100%',
    minHeight: 280,
  },
  chartPaperWide: {
    p: 2,
    borderRadius: 3,
    boxShadow: 2,
    minHeight: 260,
  },
  chartTitle: {
    fontWeight: 600,
    mb: 2,
    color: 'text.primary',
  },
  chartBox: {
    height: 260,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chartBoxShort: {
    height: 240,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableContainer: {
    borderRadius: 3,
    overflow: 'auto',
    boxShadow: 2,
    width: '100%',
  },
  tableHeadRow: {
    // backgroundColor: '#000',
  },
  tableHeadCell: {
    fontWeight: 700,
    color: '#000',
    fontSize: '0.875rem',
    py: 1.5,
    verticalAlign: 'middle',
    textAlign: 'center',
  },
  tableHeadCellBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.75,
  },
  tableHeadIcon: {
    fontSize: 18,
    opacity: 0.9,
  },
  tableEmptyCell: {
    py: 6,
    color: 'text.secondary',
  },
  tableBodyRow: {
    '&:nth-of-type(even)': { backgroundColor: 'rgba(0,0,0,0.02)' },
    '&:hover': { backgroundColor: 'rgba(126, 188, 10, 0.06)' },
    transition: 'background-color 0.2s',
  },
  tableCell: {
    py: 1.5,
    fontSize: '0.875rem',
    verticalAlign: 'middle',
    textAlign: 'center',
  },
  tableCellMonospace: {
    py: 1.5,
    fontFamily: 'monospace',
    fontSize: '0.875rem',
    verticalAlign: 'middle',
    textAlign: 'center',
  },
  tableCellDuration: {
    py: 1.5,
    fontWeight: 500,
    fontSize: '0.875rem',
    verticalAlign: 'middle',
    textAlign: 'center',
  },
  tableDirectionBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.75,
  },
  tableChip: {
    fontWeight: 600,
    fontSize: '0.75rem',
  },
  ratingStars: {
    '& .MuiRating-iconFilled': { color: '#f59e0b' },
  },
}

export const employeePermissionsStyles = {
  paper: {
    bgcolor: 'background.paper',
    p: 4,
    overflow: 'auto',
    borderRadius: 3,
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60vh',
    gap: 2,
  },
  loadingProgress: (primaryColor) => ({
    color: primaryColor,
  }),
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3,
  },
  headerLeftBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  backButton: {
    minWidth: 'auto',
    p: 1,
    color: 'inherit',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
  },
  titleTypography: {
    fontWeight: 700,
  },
  headerRightBox: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
  },
  editButton: (primaryColor) => ({
    borderColor: primaryColor,
    color: primaryColor,
    '&:hover': { borderColor: primaryColor, backgroundColor: `${primaryColor}10` },
  }),
  cancelButton: {
    borderColor: '#9e9e9e',
    color: '#9e9e9e',
    '&:hover': { borderColor: '#757575', backgroundColor: 'rgba(0,0,0,0.04)' },
  },
  saveButton: (primaryColor, primaryHover) => ({
    backgroundColor: primaryColor,
    '&:hover': { backgroundColor: primaryHover },
  }),
  alertBox: {
    mb: 3,
  },
  gridContainer: {
    maxHeight: '70vh',
    overflow: 'auto',
    alignItems: 'stretch',
  },
  gridItem: {
    display: 'flex',
    mb: 2,
  },
  roleCard: (roleColor, primaryColor) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    border: '1px solid',
    borderColor: 'divider',
    borderLeft: `4px solid ${roleColor || primaryColor}`,
    borderRadius: 2,
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease',
    '&:hover': {
      boxShadow: 4,
      borderLeft: `4px solid ${roleColor || primaryColor}`,
      transform: 'translateY(-2px)',
    },
  }),
  cardContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  chipContainerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 1,
  },
  chip: (roleColor) => ({
    backgroundColor: 'transparent',
    color: '#000000',
    fontWeight: 600,
    fontSize: '0.95rem',
  }),
  editDeleteBox: {
    display: 'flex',
    gap: 0.5,
  },
  editIconButton: (roleColor) => ({
    color: roleColor,
    transition: 'background-color 0.2s ease, transform 0.2s ease',
    '&:hover': { backgroundColor: `${roleColor}22`, transform: 'scale(1.1)' },
  }),
  deleteIconButton: {
    color: '#ef4444',
    transition: 'background-color 0.2s ease, transform 0.2s ease',
    '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.12)', transform: 'scale(1.1)' },
  },
  viewButtonBox: {
    p: 1,
    pt: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 0.5,
    alignItems: 'center',
  },
  viewIconButton: (primaryColor) => ({
    color: primaryColor,
    transition: 'background-color 0.2s ease, transform 0.2s ease',
    '&:hover': {
      backgroundColor: `${primaryColor}22`,
      transform: 'scale(1.1)',
    },
  }),
  addRoleCard: (primaryColor) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    minHeight: 140,
    border: '2px dashed',
    borderColor: 'divider',
    borderLeft: `4px solid ${primaryColor}`,
    borderRadius: 2,
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease',
    '&:hover': {
      borderLeft: `4px solid ${primaryColor}`,
      backgroundColor: `${primaryColor}12`,
      transform: 'translateY(-2px)',
    },
  }),
  addRoleCardContent: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addRoleBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
  },
  addIcon: {
    color: 'text.secondary',
    fontSize: 32,
  },
  dialogContentBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    pt: 2,
  },
  dialogSaveButton: (primaryColor) => ({
    backgroundColor: primaryColor,
  }),
}

export const groupPageStyles = {
  paper: {
    p: 3,
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 3,
    borderBottom: '2px solid rgba(0, 0, 0, 0.08)',
    pb: 2.5,
  },
  backIconButton: {
    color: greenTheme.primary,
    fontSize: 18,
  },
  backIcon: {
    fontSize: 20,
    fontWeight: 700,
  },
  alert: {
    mb: 3,
  },
  innerPaper: {
    p: 3,
    border: `1px solid ${greenTheme.primary}`,
  },
  sectionBox: {
    mb: 3,
  },
  shortNumberRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  generateButton: {
    color: greenTheme.primary,
    '&:hover': { backgroundColor: 'rgba(126, 188, 10, 0.1)' },
  },
  generateIcon: {
    fontSize: 20,
  },
  listUl: {
    padding: 0,
  },
  listSubheader: {
    lineHeight: '40px',
    fontSize: '1rem',
    fontWeight: 600,
    color: '#424242',
    backgroundColor: '#e8e8e8',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    userSelect: 'none',
  },
  expandIcon: {
    fontSize: 18,
    color: '#424242',
  },
  switch: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: greenTheme.primary,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: greenTheme.primary,
    },
  },
  toggleButtonGroup: {
    '& .MuiToggleButton-root': {
      color: greenTheme.primary,
      borderColor: greenTheme.primary,
      '&.Mui-selected': {
        backgroundColor: greenTheme.primary,
        color: '#ffffff',
        '&:hover': {
          backgroundColor: greenTheme.primary,
        },
      },
    },
  },
  employeeSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2,
  },
  addEmployeeButton: {
    ...buttonStyles,
    color: '#ffffff',
  },
  saveButtonBox: {
    mt: 4,
    display: 'flex',
    justifyContent: 'flex-end',
  },
}
